import {routerReducer as routing} from 'react-router-redux';
import {combineReducers} from 'redux';
import noticesReducer from './notices.reducer';
import userReducer from './user.reducer';
import mainBannersReducer from './mainBanners.reducer';
import identificationReducer from './identification.reducer';
import joinHistoryReducer from './joinHistory.reducer';
import addressReducer from './address.reducer';
import tournamentPrintKitRequestReducer from './tournamentPrintKitRequest.reducer';
import customerInquries from './customerInquiries.reducer';
import agreement from './agreement.reducer';
import ipManagementReducer from './ipManagement.reducer';
import usageStatus from './usageStatus.reducer';
import refundRequest from './refundRequest.reducer';
import purchase from './purchase.reducer';
import payment from './payment.reducer';
import paymentCancelRequests from './paymentCancelRequest.reducer';
import taxInvoicesReducer from './taxInvoices.reducer';
import systemMaintenanceReducer from './systemMaintenance.reducer';
import reward from './reward.reducer';

let reducers = {
  notices: noticesReducer,
  mainBanners: mainBannersReducer,
  identification: identificationReducer,
  joinHistory: joinHistoryReducer,
  user: userReducer,
  address: addressReducer,
  tournamentPrintKitRequest: tournamentPrintKitRequestReducer,
  customerInquiries: customerInquries,
  agreement: agreement,
  ipManagement: ipManagementReducer,
  usageStatus: usageStatus,
  refundRequest: refundRequest,
  paymentCancelRequest: paymentCancelRequests,
  purchase: purchase,
  payment: payment,
  taxInvoices: taxInvoicesReducer,
  systemMaintenanceNotice: systemMaintenanceReducer,
  reward: reward,
  routing: routing,
};

export default combineReducers(reducers);
